<template>
	<form class="d-print-none">
		<div class="form-row">
			<div class="form-group col-auto">
				<label for="account-id">Account ID</label>
				<input type="text" id="account-id" name="AccountID" list="customer-list" class="form-control" v-model="organisationInput" v-on:input="getAccount">
				<datalist id="customer-list">
					<option v-for="customer in customerList" :value="customer.Organisation">{{ customer.Name }} - {{ customer.AccountID }}</option>
				</datalist>
			</div>
			<div class="form-group d-flex col-auto">
				<button class="btn btn-danger ml-2 align-self-end" @click.prevent="clearInput">
					<span aria-hidden="true">
						<svg class="feather">
							<use xlink:href="../assets/feather-sprite.svg#rotate-ccw"/>
						</svg>
					</span>
					Reset
				</button>
			</div>
		</div>
	</form>
</template>

<script>
import axios from 'axios'
export default {
	name: 'OrganisationSelector',
	data: function () {
		return {
			customerList: null,
			accountDetails: null,
			accountID: '',
			organisationInput: null,
			loading: true,
			errored: false
		}
	},
	mounted () {
		axios
      .get('/api/v1/organisation/list')
      .then(response => {
        this.customerList = response.data;
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => this.loading = false)
	},
	methods: {
		clearInput: function () {
			this.organisationInput = null;
			this.getAccount();
		},
		getAccount: function () {
			if (this.organisationInput) {
				axios
					.get('/api/v1/organisation/'+this.organisationInput+'/full')
					.then(response => {
						if (response.headers['content-type'] === 'application/json') {
							this.accountDetails = response.data;
							if (this.accountDetails.Organisation){
								this.$emit('passAccountDetails', this.accountDetails);
							}
						}
					}).catch(error => {
						console.log(error)
						this.errored = true
					})
					.finally(() => this.loading = false)
			} else {
				this.$emit('passAccountDetails', '');
			}
		}
	}
}
</script>
